import { Col, Row } from "taltech-styleguide";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { BuildingSpecParameter, ParametersTable } from "./ParametersTable";
import { OverlayTooltip } from "./OverlayTooltip";
import { FC } from "react";
import { CreationTypeEnum } from "./BuildingSpecificationForm";

type Props = {
  data: any;
  parameters: {
    windowType: BuildingSpecParameter[];
    floor: BuildingSpecParameter[];
    floorGround: BuildingSpecParameter[];
    roof: BuildingSpecParameter[];
    wallInterior: BuildingSpecParameter[];
    wallExterior: BuildingSpecParameter[];
    buildingParameters: BuildingSpecParameter[];
  };
};

export const ComponentsInfoComponent: FC<Props> = ({ data, parameters }) => {
  return (
    <div className="build-spec-section">
      <div className="section-header">
        <h5>Components</h5>
      </div>
      <div className="section-body">
        <Row>
          <Col xs="9">
            <label>
              <span>Window Type:</span>
              <OverlayTooltip
                data={{
                  creationType: data.windowType.creationType,
                  parameters: parameters.windowType,
                }}
                component={DynamicTooltip}
              >
                <span>{data.windowType.name}</span>
              </OverlayTooltip>
            </label>
          </Col>
          <Col xs="3">
            {data.windowType.creationType === CreationTypeEnum.RANDOM ? (
              <img
                src={"/Random.svg"}
                alt={"success Shuffle"}
                className={"ebd-shuffle-btn"}
              />
            ) : (
              <img
                src={"/Not_Random.svg"}
                alt={"success Shuffle"}
                className={"ebd-shuffle-btn"}
              />
            )}
          </Col>
        </Row>
        <Row>
          <Col xs="9">
            <label>
              <span>Floor:</span>
              <OverlayTooltip
                data={{
                  creationType: data.floor.creationType,
                  parameters: parameters.floor,
                }}
                component={DynamicTooltip}
              >
                <span>{data.floor.value}</span>
              </OverlayTooltip>
            </label>
          </Col>
          <Col xs="3">
            {data.floor.creationType === CreationTypeEnum.RANDOM ? (
              <img
                src={"/Random.svg"}
                alt={"success Shuffle"}
                className={"ebd-shuffle-btn"}
              />
            ) : (
              <img
                src={"/Not_Random.svg"}
                alt={"success Shuffle"}
                className={"ebd-shuffle-btn"}
              />
            )}
          </Col>
        </Row>
        <Row>
          <Col xs="9">
            <label>
              <span>Floor Ground:</span>
              <OverlayTooltip
                data={{
                  creationType: data.floorGround.creationType,
                  parameters: parameters.floorGround,
                }}
                component={DynamicTooltip}
              >
                <span>{data.floorGround.value}</span>
              </OverlayTooltip>
            </label>
          </Col>
          <Col xs="3">
            {data.floorGround.creationType === CreationTypeEnum.RANDOM ? (
              <img
                src={"/Random.svg"}
                alt={"success Shuffle"}
                className={"ebd-shuffle-btn"}
              />
            ) : (
              <img
                src={"/Not_Random.svg"}
                alt={"success Shuffle"}
                className={"ebd-shuffle-btn"}
              />
            )}
          </Col>
        </Row>
        <Row>
          <Col xs="9">
            <label>
              <span>Roof:</span>
              <OverlayTooltip
                data={{
                  creationType: data.roof.creationType,
                  parameters: parameters.roof,
                }}
                component={DynamicTooltip}
              >
                <span>{data.roof.value}</span>
              </OverlayTooltip>
            </label>
          </Col>
          <Col xs="3">
            {data.roof.creationType === CreationTypeEnum.RANDOM ? (
              <img
                src={"/Random.svg"}
                alt={"success Shuffle"}
                className={"ebd-shuffle-btn"}
              />
            ) : (
              <img
                src={"/Not_Random.svg"}
                alt={"success Shuffle"}
                className={"ebd-shuffle-btn"}
              />
            )}
          </Col>
        </Row>
        <Row>
          <Col xs="9">
            <label>
              <span>Wall Interior:</span>
              <OverlayTooltip
                data={{
                  creationType: data.wallInterior.creationType,
                  parameters: parameters.wallInterior,
                }}
                component={DynamicTooltip}
              >
                <span>{data.wallInterior.value}</span>
              </OverlayTooltip>
            </label>
          </Col>
          <Col xs="3">
            {data.wallInterior.creationType === CreationTypeEnum.RANDOM ? (
              <img
                src={"/Random.svg"}
                alt={"success Shuffle"}
                className={"ebd-shuffle-btn"}
              />
            ) : (
              <img
                src={"/Not_Random.svg"}
                alt={"success Shuffle"}
                className={"ebd-shuffle-btn"}
              />
            )}
          </Col>
        </Row>
        <Row>
          <Col xs="9">
            <label>
              <span>Wall Exterior:</span>
              <OverlayTooltip
                data={{
                  creationType: data.wallExterior.creationType,
                  parameters: parameters.wallExterior,
                }}
                component={DynamicTooltip}
              >
                <span>{data.wallExterior.value}</span>
              </OverlayTooltip>
            </label>
          </Col>
          <Col xs="3">
            {data.wallExterior.creationType === CreationTypeEnum.RANDOM ? (
              <img
                src={"/Random.svg"}
                alt={"success Shuffle"}
                className={"ebd-shuffle-btn"}
              />
            ) : (
              <img
                src={"/Not_Random.svg"}
                alt={"success Shuffle"}
                className={"ebd-shuffle-btn"}
              />
            )}
          </Col>
        </Row>
        {/* <Row>
          <Col xs="9">
            <label>
              <span>
                Building Parameters:{" "}
                <OverlayTooltip
                  data={{
                    creationType: data.buildingParameters.creationType,
                    parameters: parameters.buildingParameters,
                  }}
                  component={DynamicTooltip}
                >
                  {data.buildingParameters.value}
                </OverlayTooltip>
              </span>
            </label>
          </Col>
          <Col xs="3">
            {data.buildingParameters.creationType === CreationTypeEnum.RANDOM ? (
              <img
                src={"/Random.svg"}
                alt={"success Shuffle"}
                className={"ebd-shuffle-btn"}
              />
            ) : (
              <img
                src={"/Not_Random.svg"}
                alt={"success Shuffle"}
                className={"ebd-shuffle-btn"}
              />
            )}
          </Col>
        </Row> */}
      </div>
    </div>
  );
};

const DynamicTooltip = ({ creationType, parameters }: any) => (
  <Tooltip style={{ position: "fixed" }}>
    <ParametersTable
      creationType={creationType}
      parameters={parameters}
    ></ParametersTable>
  </Tooltip>
);
